import {Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Typography,} from '@material-ui/core';
import {Content, DocsIcon, Header, InfoCard, Page,} from '@backstage/core-components';
import {HomePageStarredEntities, WelcomeTitle} from '@backstage/plugin-home';
import {Link} from 'react-router-dom';

export const HomePage = () => {
  return (
    <Page themeId="home">
      <Header title={<WelcomeTitle />} pageTitleOverride="Home" />
      <Content>
        <Grid container>
          <Grid item xs={12}>
            <InfoCard title="What is Irie?">
              <Typography variant="body2">
                Irie helps you build and run services around the Digital Twin –
                without complexity. You get a smooth, reliable developer
                experience and can focus on building great software.
              </Typography>
              <List style={{ paddingTop: 16, paddingBottom: 0 }}>
                <ListItem
                  dense
                  button
                  component={Link}
                  to="/catalog/default/domain/irie-os"
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <ListItemIcon>
                    <IconButton
                      component={Link}
                      to="/docs/default/domain/irie-os"
                    >
                      <DocsIcon />
                    </IconButton>
                  </ListItemIcon>
                  <ListItemText
                    primary="Irie OS"
                    secondary="Your operating system with all essential base
                      components."
                  />
                </ListItem>
                <ListItem
                  dense
                  button
                  component={Link}
                  to="/catalog/default/system/irie-idp"
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <ListItemIcon>
                    <IconButton
                      component={Link}
                      to="/docs/default/system/irie-idp"
                    >
                      <DocsIcon />
                    </IconButton>
                  </ListItemIcon>
                  <ListItemText
                    primary="Irie IDP"
                    secondary="Your internal developer platform to develop, test, and
                      deploy faster."
                  />
                </ListItem>
              </List>
            </InfoCard>
          </Grid>
          <Grid item xs={12}>
            <HomePageStarredEntities />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
